/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as DownloadsRouteImport } from "./routes/downloads"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as AuthRouteImport } from "./routes/_auth"
import { Route as AuthenticatedIndexRouteImport } from "./routes/_authenticated/index"
import { Route as AuthenticatedTimetableRouteImport } from "./routes/_authenticated/timetable"
import { Route as AuthenticatedSettingsRouteImport } from "./routes/_authenticated/settings"
import { Route as AuthenticatedResultsRouteImport } from "./routes/_authenticated/results"
import { Route as AuthenticatedRemindersRouteImport } from "./routes/_authenticated/reminders"
import { Route as AuthenticatedNotificationsRouteImport } from "./routes/_authenticated/notifications"
import { Route as AuthenticatedMyexamRouteImport } from "./routes/_authenticated/myexam"
import { Route as AuthenticatedMoreRouteImport } from "./routes/_authenticated/more"
import { Route as AuthenticatedInternalMarksRouteImport } from "./routes/_authenticated/internal-marks"
import { Route as AuthenticatedCoursesRouteImport } from "./routes/_authenticated/courses"
import { Route as AuthenticatedCommonBreaksRouteImport } from "./routes/_authenticated/common-breaks"
import { Route as AuthenticatedBiometricRouteImport } from "./routes/_authenticated/biometric"
import { Route as AuthenticatedAttendanceRouteImport } from "./routes/_authenticated/attendance"
import { Route as AuthPrivacyRouteImport } from "./routes/_auth/privacy"
import { Route as AuthLoginRouteImport } from "./routes/_auth/login"

const DownloadsRoute = DownloadsRouteImport.update({
  id: "/downloads",
  path: "/downloads",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: "/_auth",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTimetableRoute = AuthenticatedTimetableRouteImport.update({
  id: "/timetable",
  path: "/timetable",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedResultsRoute = AuthenticatedResultsRouteImport.update({
  id: "/results",
  path: "/results",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRemindersRoute = AuthenticatedRemindersRouteImport.update({
  id: "/reminders",
  path: "/reminders",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyexamRoute = AuthenticatedMyexamRouteImport.update({
  id: "/myexam",
  path: "/myexam",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMoreRoute = AuthenticatedMoreRouteImport.update({
  id: "/more",
  path: "/more",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInternalMarksRoute =
  AuthenticatedInternalMarksRouteImport.update({
    id: "/internal-marks",
    path: "/internal-marks",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCoursesRoute = AuthenticatedCoursesRouteImport.update({
  id: "/courses",
  path: "/courses",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCommonBreaksRoute =
  AuthenticatedCommonBreaksRouteImport.update({
    id: "/common-breaks",
    path: "/common-breaks",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBiometricRoute = AuthenticatedBiometricRouteImport.update({
  id: "/biometric",
  path: "/biometric",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAttendanceRoute = AuthenticatedAttendanceRouteImport.update({
  id: "/attendance",
  path: "/attendance",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthPrivacyRoute = AuthPrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute
  "/downloads": typeof DownloadsRoute
  "/login": typeof AuthLoginRoute
  "/privacy": typeof AuthPrivacyRoute
  "/attendance": typeof AuthenticatedAttendanceRoute
  "/biometric": typeof AuthenticatedBiometricRoute
  "/common-breaks": typeof AuthenticatedCommonBreaksRoute
  "/courses": typeof AuthenticatedCoursesRoute
  "/internal-marks": typeof AuthenticatedInternalMarksRoute
  "/more": typeof AuthenticatedMoreRoute
  "/myexam": typeof AuthenticatedMyexamRoute
  "/notifications": typeof AuthenticatedNotificationsRoute
  "/reminders": typeof AuthenticatedRemindersRoute
  "/results": typeof AuthenticatedResultsRoute
  "/settings": typeof AuthenticatedSettingsRoute
  "/timetable": typeof AuthenticatedTimetableRoute
}
export interface FileRoutesByTo {
  "/": typeof AuthenticatedIndexRoute
  "/downloads": typeof DownloadsRoute
  "/login": typeof AuthLoginRoute
  "/privacy": typeof AuthPrivacyRoute
  "/attendance": typeof AuthenticatedAttendanceRoute
  "/biometric": typeof AuthenticatedBiometricRoute
  "/common-breaks": typeof AuthenticatedCommonBreaksRoute
  "/courses": typeof AuthenticatedCoursesRoute
  "/internal-marks": typeof AuthenticatedInternalMarksRoute
  "/more": typeof AuthenticatedMoreRoute
  "/myexam": typeof AuthenticatedMyexamRoute
  "/notifications": typeof AuthenticatedNotificationsRoute
  "/reminders": typeof AuthenticatedRemindersRoute
  "/results": typeof AuthenticatedResultsRoute
  "/settings": typeof AuthenticatedSettingsRoute
  "/timetable": typeof AuthenticatedTimetableRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_auth": typeof AuthRouteWithChildren
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/downloads": typeof DownloadsRoute
  "/_auth/login": typeof AuthLoginRoute
  "/_auth/privacy": typeof AuthPrivacyRoute
  "/_authenticated/attendance": typeof AuthenticatedAttendanceRoute
  "/_authenticated/biometric": typeof AuthenticatedBiometricRoute
  "/_authenticated/common-breaks": typeof AuthenticatedCommonBreaksRoute
  "/_authenticated/courses": typeof AuthenticatedCoursesRoute
  "/_authenticated/internal-marks": typeof AuthenticatedInternalMarksRoute
  "/_authenticated/more": typeof AuthenticatedMoreRoute
  "/_authenticated/myexam": typeof AuthenticatedMyexamRoute
  "/_authenticated/notifications": typeof AuthenticatedNotificationsRoute
  "/_authenticated/reminders": typeof AuthenticatedRemindersRoute
  "/_authenticated/results": typeof AuthenticatedResultsRoute
  "/_authenticated/settings": typeof AuthenticatedSettingsRoute
  "/_authenticated/timetable": typeof AuthenticatedTimetableRoute
  "/_authenticated/": typeof AuthenticatedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/downloads"
    | "/login"
    | "/privacy"
    | "/attendance"
    | "/biometric"
    | "/common-breaks"
    | "/courses"
    | "/internal-marks"
    | "/more"
    | "/myexam"
    | "/notifications"
    | "/reminders"
    | "/results"
    | "/settings"
    | "/timetable"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/downloads"
    | "/login"
    | "/privacy"
    | "/attendance"
    | "/biometric"
    | "/common-breaks"
    | "/courses"
    | "/internal-marks"
    | "/more"
    | "/myexam"
    | "/notifications"
    | "/reminders"
    | "/results"
    | "/settings"
    | "/timetable"
  id:
    | "__root__"
    | "/_auth"
    | "/_authenticated"
    | "/downloads"
    | "/_auth/login"
    | "/_auth/privacy"
    | "/_authenticated/attendance"
    | "/_authenticated/biometric"
    | "/_authenticated/common-breaks"
    | "/_authenticated/courses"
    | "/_authenticated/internal-marks"
    | "/_authenticated/more"
    | "/_authenticated/myexam"
    | "/_authenticated/notifications"
    | "/_authenticated/reminders"
    | "/_authenticated/results"
    | "/_authenticated/settings"
    | "/_authenticated/timetable"
    | "/_authenticated/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  DownloadsRoute: typeof DownloadsRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/downloads": {
      id: "/downloads"
      path: "/downloads"
      fullPath: "/downloads"
      preLoaderRoute: typeof DownloadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_auth": {
      id: "/_auth"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/": {
      id: "/_authenticated/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/timetable": {
      id: "/_authenticated/timetable"
      path: "/timetable"
      fullPath: "/timetable"
      preLoaderRoute: typeof AuthenticatedTimetableRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/settings": {
      id: "/_authenticated/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/results": {
      id: "/_authenticated/results"
      path: "/results"
      fullPath: "/results"
      preLoaderRoute: typeof AuthenticatedResultsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/reminders": {
      id: "/_authenticated/reminders"
      path: "/reminders"
      fullPath: "/reminders"
      preLoaderRoute: typeof AuthenticatedRemindersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/notifications": {
      id: "/_authenticated/notifications"
      path: "/notifications"
      fullPath: "/notifications"
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/myexam": {
      id: "/_authenticated/myexam"
      path: "/myexam"
      fullPath: "/myexam"
      preLoaderRoute: typeof AuthenticatedMyexamRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/more": {
      id: "/_authenticated/more"
      path: "/more"
      fullPath: "/more"
      preLoaderRoute: typeof AuthenticatedMoreRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/internal-marks": {
      id: "/_authenticated/internal-marks"
      path: "/internal-marks"
      fullPath: "/internal-marks"
      preLoaderRoute: typeof AuthenticatedInternalMarksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/courses": {
      id: "/_authenticated/courses"
      path: "/courses"
      fullPath: "/courses"
      preLoaderRoute: typeof AuthenticatedCoursesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/common-breaks": {
      id: "/_authenticated/common-breaks"
      path: "/common-breaks"
      fullPath: "/common-breaks"
      preLoaderRoute: typeof AuthenticatedCommonBreaksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/biometric": {
      id: "/_authenticated/biometric"
      path: "/biometric"
      fullPath: "/biometric"
      preLoaderRoute: typeof AuthenticatedBiometricRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/attendance": {
      id: "/_authenticated/attendance"
      path: "/attendance"
      fullPath: "/attendance"
      preLoaderRoute: typeof AuthenticatedAttendanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_auth/privacy": {
      id: "/_auth/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof AuthPrivacyRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/login": {
      id: "/_auth/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthPrivacyRoute: typeof AuthPrivacyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthPrivacyRoute: AuthPrivacyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAttendanceRoute: typeof AuthenticatedAttendanceRoute
  AuthenticatedBiometricRoute: typeof AuthenticatedBiometricRoute
  AuthenticatedCommonBreaksRoute: typeof AuthenticatedCommonBreaksRoute
  AuthenticatedCoursesRoute: typeof AuthenticatedCoursesRoute
  AuthenticatedInternalMarksRoute: typeof AuthenticatedInternalMarksRoute
  AuthenticatedMoreRoute: typeof AuthenticatedMoreRoute
  AuthenticatedMyexamRoute: typeof AuthenticatedMyexamRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedRemindersRoute: typeof AuthenticatedRemindersRoute
  AuthenticatedResultsRoute: typeof AuthenticatedResultsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedTimetableRoute: typeof AuthenticatedTimetableRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAttendanceRoute: AuthenticatedAttendanceRoute,
  AuthenticatedBiometricRoute: AuthenticatedBiometricRoute,
  AuthenticatedCommonBreaksRoute: AuthenticatedCommonBreaksRoute,
  AuthenticatedCoursesRoute: AuthenticatedCoursesRoute,
  AuthenticatedInternalMarksRoute: AuthenticatedInternalMarksRoute,
  AuthenticatedMoreRoute: AuthenticatedMoreRoute,
  AuthenticatedMyexamRoute: AuthenticatedMyexamRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedRemindersRoute: AuthenticatedRemindersRoute,
  AuthenticatedResultsRoute: AuthenticatedResultsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedTimetableRoute: AuthenticatedTimetableRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  DownloadsRoute: DownloadsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
